import React from 'react';
import {
  useFormContext,
  Controller,
  UseControllerProps,
} from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Input, { InputProps } from '@mui/material/Input';
import InputLabel, { InputLabelProps } from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import omit from 'lodash-es/omit';

type FormPasswordProps = UseControllerProps & {
  inner_props?: {
    className?: string;
    input_label_props?: InputLabelProps;
    input_props?: InputProps & {
      // Получается костыль, чтобы использовать
      // компонент из вне по единообразию с TextField
      helperText: string;
    };
  };
};

export default function FormPassword(props: FormPasswordProps) {
  const [state, setState] = React.useState({
    password: '',
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownPassword = (event: React.MouseEvent) => {
    event.preventDefault();
  };

  const { control } = useFormContext();
  const { name } = props;

  // Теперь нужно выкинуть из пропсов helperText, так как в оригинале его нет
  const input_props = omit(props?.inner_props?.input_props, 'helperText');
  const helper_text = props?.inner_props?.input_props?.helperText || '';

  return (
    <Controller
      name={name}
      control={control}
      rules={props.rules}
      render={({ field }) => (
        <FormControl
          className={props?.inner_props?.className}
          variant="standard"
          // FormControl прокинет error в FormHelperText
          error={input_props.error}
        >
          <InputLabel
            htmlFor="standard-adornment-password"
            {...props?.inner_props?.input_label_props}
          ></InputLabel>
          <Input
            {...field}
            {...input_props}
            onChange={(e) => {
              field.onChange(e);
              if (input_props.onChange) {
                input_props.onChange(e);
              }
            }}
            id="standard-adornment-password"
            type={state.showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText>{helper_text}</FormHelperText>
        </FormControl>
      )}
    />
  );
}
